import { publish, PubSubMessageType, SubscriptionTopic } from '../../viewer/messaging/pubsub';

export const useToast = () => {
  const showToast = (options: PubSubMessageType<SubscriptionTopic.ToastrMessage>) => {
    publish(SubscriptionTopic.ToastrMessage, options);
  };

  return {
    showToast,
  };
};
